import React from 'react';
import {Link, Sheet, Tab, tabClasses, TabList, TabPanel, Tabs, useColorScheme} from '@mui/joy';
import Skills from "./Skills";
import Educations from "./Educations";
import Services from "./Services";
import Experiences from "./Experiences";
import {EducationModel} from "../model/education";
import {ExperienceModel} from "../model/experience";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";

function Demo(props:{
    education:Array<EducationModel>,
    experience: Array<ExperienceModel>,
    skill: Array<SkillModel>,
    service: Array<ServiceModel>
}) {
    const {mode, setMode} = useColorScheme();
    const {education, experience, skill,service} = props;
    return (
        <Sheet sx={{paddingY: 4}} id='demo'>
            <Tabs orientation="horizontal" aria-label="tabs" defaultValue={0} sx={{bgcolor: 'transparent'}}>
                <TabList
                    disableUnderline
                    sx={{
                        p: 0.5,
                        //gap: 0.5,
                        borderRadius: 'xl',
                        //bgcolor: 'neutral.800',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'primary.700',
                            color: mode == 'dark' ? 'neutral.900' : 'primary.50',
                        },
                    }}
                >
                    <Link href="#demo" variant="plain" color='neutral' underline="none">
                        <Tab sx={{p:0.6}} disableIndicator>Skills</Tab>
                    </Link>
                    <Link href="#demo" variant="plain" color='neutral' underline="none">
                        <Tab sx={{p:0.6}} disableIndicator>Services</Tab>
                    </Link>
                    <Link href="#demo" variant="plain" color='neutral' underline="none">
                        <Tab sx={{p:0.6}} disableIndicator>Educations</Tab>
                    </Link>
                    <Link href="#demo" variant="plain" color='neutral' underline="none">
                        <Tab sx={{p:0.6}}disableIndicator>Experiences</Tab>
                    </Link>
                </TabList>

                <TabPanel value={0}>
                    <Skills skills = {skill} />
                </TabPanel>
                <TabPanel value={1}>
                    <Services services = {service}/>
                </TabPanel>
                <TabPanel value={2}>
                    <Educations educations = {education} />
                </TabPanel>
                <TabPanel value={3}>
                    <Experiences experiences = {experience}/>
                </TabPanel>
            </Tabs>
        </Sheet>
    );
}

export default Demo;